mutation DeleteTrivia($triviaId: ID!) {
  result: StreamToolsDeleteTrivia(triviaId: $triviaId) {
    id
    deleted
  }
}
